import VIButton from 'general/components/VietInvoice/VIButton';
import VIDateRangePickerInput from 'general/components/VietInvoice/VIDateRangePicker';
import VISelectFilter from 'general/components/VietInvoice/VISelectFilter';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './style.scss';
import { Dropdown } from 'react-bootstrap';
import Global from 'general/utils/Global';
import { useDispatch } from 'react-redux';
import { thunkGetAllOutInvoice } from 'features/Invoice/invoiceSlice';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import Utils from 'general/utils/Utils';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import useAccount from 'hooks/useAccount';

function DropdownFilterOutInvoice(props) {
  const { handleFilterInvoice, refDropdownFilterOutputMenu } = props;
  const statusInvoice = [
    {
      name: 'Tất cả',
      value: 0,
    },
    {
      name: 'HĐ mới',
      value: 1,
    },
    {
      name: 'HĐ thay thế',
      value: 2,
    },
    {
      name: 'HĐ điều chỉnh',
      value: 3,
    },
    {
      name: 'HĐ đã bị thay thế',
      value: 4,
    },
    {
      name: 'HĐ đã bị điều chỉnh',
      value: 5,
    },
    {
      name: 'HĐ đã bị hủy',
      value: 6,
    },
    {
      name: 'HĐ chưa xác định',
      value: 7,
    },
    {
      name: 'HĐ lưu nháp',
      value: 8,
    },
  ];
  const typeInvoice = [
    {
      name: 'Tất cả',
      value: 0,
    },
    {
      name: 'có XML',
      value: 1,
    },
    {
      name: 'Không có XML',
      value: 2,
    },
  ];
  const TypeCode = [
    {
      name: 'Tất cả',
      value: 0,
    },
    {
      name: 'HĐ giá trị gia tăng',
      value: 1,
    },
    {
      name: 'HĐ bán hàng',
      value: 2,
    },
    {
      name: 'HĐ bán tài sản công',
      value: 3,
    },
    {
      name: 'HĐ bán hàng dự trữ quốc gia',
      value: 4,
    },
    {
      name: 'Tem, vé, thẻ điện tử',
      value: 5,
    },
    {
      name: 'Phiếu xuất kho điện tử',
      value: 6,
    },
  ];
  const serial = [
    {
      name: 'Tất cả',
      value: 0,
    },
    {
      name: 'Hóa đơn có mã',
      value: 'C',
    },
    {
      name: 'Hóa đơn không mã',
      value: 'K',
    },
  ];
  const account = useAccount();

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [dataFilters, setDataFilters] = useState({
    typeInvoice:
      JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
        Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
      ]?.typeInvoice ?? typeInvoice[0]?.value,
    statusInvoice:
      JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
        Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
      ]?.statusInvoice ?? statusInvoice[0]?.value,
    invoiceTypeCode:
      JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
        Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
      ]?.invoiceTypeCode ?? TypeCode[0]?.value,
    invoiceSerialType:
      JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
        Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
      ]?.invoiceSerialType ?? serial[0]?.value,
    fromDate:
      JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
        Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
      ]?.fromDate ?? moment().subtract(29, 'days').format('YYYY-MM-DD'),
    toDate:
      JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
        Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
      ]?.toDate ?? moment().format('YYYY-MM-DD'),
    dateRangeLabel: JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
      Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
    ]?.dateRangeLabel,
  });

  useEffect(() => {
    if (Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId)) !== undefined) {
      setDataFilters({
        typeInvoice:
          JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
            Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
          ]?.typeInvoice ?? typeInvoice[0]?.value,
        statusInvoice:
          JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
            Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
          ]?.statusInvoice ?? statusInvoice[0]?.value,
        invoiceTypeCode:
          JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
            Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
          ]?.invoiceTypeCode ?? TypeCode[0]?.value,
        invoiceSerialType:
          JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
            Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
          ]?.invoiceSerialType ?? serial[0]?.value,
        fromDate:
          JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
            Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
          ]?.fromDate ?? moment().subtract(29, 'days').format('YYYY-MM-DD'),
        toDate:
          JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
            Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
          ]?.toDate ?? moment().format('YYYY-MM-DD'),
        dateRangeLabel: JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
          Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
        ]?.dateRangeLabel,
      });
      Global.gFiltersOutputInvoice = {
        ...Global.gFiltersOutputInvoice,
        typeInvoice:
          JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
            Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
          ]?.typeInvoice ?? typeInvoice[0]?.value,
        statusInvoice:
          JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
            Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
          ]?.statusInvoice ?? statusInvoice[0]?.value,
        invoiceTypeCode:
          JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
            Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
          ]?.invoiceTypeCode ?? TypeCode[0]?.value,
        invoiceSerialType:
          JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
            Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
          ]?.invoiceSerialType ?? serial[0]?.value,
        fromDate:
          JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
            Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
          ]?.fromDate ?? moment().subtract(29, 'days').format('YYYY-MM-DD'),
        toDate:
          JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
            Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
          ]?.toDate ?? moment().format('YYYY-MM-DD'),
        dateRangeLabel: JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice))?.[
          Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))
        ]?.dateRangeLabel,
      };
    }
  }, [Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))]);

  const handleSubmit = () => {
    if (handleFilterInvoice) {
      handleFilterInvoice(dataFilters);
    }
    Global.gFiltersOutputInvoice = {
      ...Global.gFiltersOutputInvoice,
      fromDate: dataFilters?.fromDate,
      toDate: dataFilters?.toDate,
      statusInvoice: dataFilters?.statusInvoice,
      invoiceTypeCode: dataFilters?.invoiceTypeCode,
      invoiceSerialType: dataFilters?.invoiceSerialType,
      typeInvoice: dataFilters?.typeInvoice,
      page: 0,
      dateRangeLabel: dataFilters.dateRangeLabel,
    };
    localStorage.setItem(
      PreferenceKeys.saveOutputInvoice,
      JSON.stringify({
        ...JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice)),
        [Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))]: {
          ...Global.gFiltersOutputInvoice,
          fromDate: dataFilters?.fromDate,
          toDate: dataFilters?.toDate,
          statusInvoice: dataFilters?.statusInvoice,
          invoiceTypeCode: dataFilters?.invoiceTypeCode,
          invoiceSerialType: dataFilters?.invoiceSerialType,
          typeInvoice: dataFilters?.typeInvoice,
          dateRangeLabel: dataFilters.dateRangeLabel,
          page: 0,
        },
      })
    );
    refDropdownFilterOutputMenu?.current.classList.remove('show');
  };
  const handleClose = () => {
    refDropdownFilterOutputMenu?.current.classList.remove('show');

    setDataFilters({
      typeInvoice: typeInvoice[0]?.value,
      statusInvoice: statusInvoice[0]?.value,
      invoiceTypeCode: TypeCode[0]?.value,
      invoiceSerialType: serial[0]?.value,
      fromDate: moment().subtract(29, 'days').format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      dateRangeLabel: '30 ngày gần đây',
    });
    Global.gFiltersOutputInvoice = {
      ...Global.gFiltersOutputInvoice,
      statusInvoice: statusInvoice[0]?.value,
      typeInvoice: typeInvoice[0]?.value,
      invoiceTypeCode: TypeCode[0]?.value,
      invoiceSerialType: serial[0]?.value,
      fromDate: moment().subtract(29, 'days').format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      dateRangeLabel: '30 ngày gần đây',
      page: 0,
    };
    localStorage.setItem(
      PreferenceKeys.saveOutputInvoice,
      JSON.stringify({
        ...JSON.parse(localStorage.getItem(PreferenceKeys.saveOutputInvoice)),
        [Number(localStorage.getItem(PreferenceKeys.savedLoginAccountId))]: {
          ...Global.gFiltersOutputInvoice,
          statusInvoice: statusInvoice[0]?.value,
          typeInvoice: typeInvoice[0]?.value,
          invoiceTypeCode: TypeCode[0]?.value,
          invoiceSerialType: serial[0]?.value,
          fromDate: moment().subtract(29, 'days').format('YYYY-MM-DD'),
          toDate: moment().format('YYYY-MM-DD'),
          dateRangeLabel: '30 ngày gần đây',
          page: 0,
        },
      })
    );
    dispatch(thunkGetAllOutInvoice(Global.gFiltersOutputInvoice));
  };
  return (
    <div className="px-5 py-2">
      <div className="font-size-h3 font-weight-bold mb-3">{t('FilterInvoices')}</div>

      <div className="d-flex mb-3 flex-column flex-md-row">
        <div className="me-4 w-100 ">
          <div className="w-100 ">
            <span className="font-size-lg font-weight-bold ">{t('Status')}</span>
            <VISelectFilter
              data={statusInvoice}
              onChangeValue={(e) => {
                setDataFilters({ ...dataFilters, statusInvoice: e?.value });
                Global.gFiltersOutputInvoice = {
                  ...Global.gFiltersOutputInvoice,
                  statusInvoice: e?.value,
                };
              }}
              CurrentSelect={dataFilters?.statusInvoice}
              className="w-100 mt-2"
              CloseDropdown="status"
            />
          </div>
        </div>
        <div className="mt-screen w-100">
          <div className="w-100 ">
            <span className="font-size-lg font-weight-bold ">{t('InvoiceType')}</span>
            <VISelectFilter
              data={typeInvoice}
              onChangeValue={(e) => {
                setDataFilters({ ...dataFilters, typeInvoice: e?.value });
                Global.gFiltersOutputInvoice = {
                  ...Global.gFiltersOutputInvoice,
                  typeInvoice: e?.value,
                };
              }}
              CurrentSelect={dataFilters?.typeInvoice}
              className="w-100 mt-2"
              CloseDropdown="type-invoice"
            />
          </div>
        </div>
      </div>
      <div className="d-flex mb-3 flex-column flex-md-row">
        <div className="w-100 me-4">
          <div className="font-size-lg font-weight-bold " style={{ minWidth: 'max-content' }}>
            {t('InvoiceTemplate')}
          </div>
          <VISelectFilter
            data={TypeCode}
            onChangeValue={(e) => {
              setDataFilters({ ...dataFilters, invoiceTypeCode: e?.value });
            }}
            CurrentSelect={dataFilters?.invoiceTypeCode}
            className="w-100 mt-2"
            CloseDropdown="InvoiceTemplate"
            style={{
              minWidth: '150px',
              maxWidth: '240px',
              textOverflow: 'clip',
              overflow: 'hidden',
            }}
          />
        </div>
        <div className="w-100 mt-screen">
          <div className="font-size-lg font-weight-bold " style={{ minWidth: 'max-content' }}>
            {t('InvoiceForm')}
          </div>
          <VISelectFilter
            data={serial}
            onChangeValue={(e) => {
              setDataFilters({ ...dataFilters, invoiceSerialType: e?.value });
              // Global.gFiltersInputInvoice = {
              //   ...Global.gFiltersInputInvoice,
              //   invoiceSerialType: e?.value,
              // };
            }}
            CurrentSelect={dataFilters?.invoiceSerialType}
            className="w-100 mt-2 "
            CloseDropdown="InvoiceForm"
            style={{ minWidth: '150px' }}
          />
        </div>
      </div>
      <p className={`mb-1 font-weight-bold`}>{t('FromDate')}</p>
      <KTFormGroup
        additionalClassName=" mb-3"
        inputName="date"
        inputElement={
          <div>
            <KTFormInput
              name="date"
              value={Utils.formatDateTime(dataFilters.fromDate, 'YYYY-MM-DD')}
              onChange={(value) => {
                setDataFilters({
                  ...dataFilters,
                  fromDate: moment(value)?.format('YYYY-MM-DD'),
                });
                Global.gFiltersOutputInvoice = {
                  ...Global.gFiltersOutputInvoice,
                  fromDate: moment(value)?.format('YYYY-MM-DD'),
                };
              }}
              enableCheckValid
              type={KTFormInputType.date}
              placeholder={`${_.capitalize(t('SelectPaymentDate'))}`}
              enableInputGroup={true}
              prependElements={[<i className="fa-regular fa-calendar-clock"></i>]}
            />
          </div>
        }
      />
      <p className={`mb-1 font-weight-bold`}>{t('ToDate')}</p>
      <KTFormGroup
        additionalClassName=" mb-3"
        inputName="date"
        inputElement={
          <div>
            <KTFormInput
              name="date"
              value={Utils.formatDateTime(dataFilters.toDate, 'YYYY-MM-DD')}
              onChange={(value) => {
                setDataFilters({
                  ...dataFilters,
                  toDate: moment(value)?.format('YYYY-MM-DD'),
                });
                Global.gFiltersOutputInvoice = {
                  ...Global.gFiltersOutputInvoice,
                  toDate: moment(value)?.format('YYYY-MM-DD'),
                };
              }}
              enableCheckValid
              type={KTFormInputType.date}
              placeholder={`${_.capitalize(t('SelectPaymentDate'))}`}
              enableInputGroup={true}
              prependElements={[<i className="fa-regular fa-calendar-clock"></i>]}
            />
          </div>
        }
      />
      <div className="d-flex justify-content-between button-filter mb-2">
        <div className="btn-resets" style={{ width: '100px' }}>
          {/* <VIButton
                  text={t('ResetToDefault')}
                  beforeIcon={<i className="fa-solid fa-arrow-rotate-right"></i>}
                  className=" btn-white w-100 "
                  style={{ padding: '8px' }}
                  onClick={() => {}}
                  afterIcon={<></>}
                /> */}
        </div>
        <div className="d-flex btn-submit-filter">
          <VIButton
            text={t('DeselectFilter')}
            beforeIcon={<></>}
            className="btn-white me-3"
            style={{ padding: '8px' }}
            onClick={() => {
              handleClose();
            }}
            afterIcon={<></>}
          />
          <VIButton
            text={t('Save')}
            beforeIcon={<></>}
            className=""
            style={{ padding: '8px' }}
            onClick={() => {
              handleSubmit();
            }}
            afterIcon={<></>}
          />
        </div>
      </div>
    </div>
  );
}

export default DropdownFilterOutInvoice;
